module.exports = __webpack_public_path__ + "static/media/logo.74b5bd65.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 347
// module chunks = 120